import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button
} from '@mui/material';

import PlataformaTenantSubtabla from '../plataformaTenantSubtabla/PlataformaTenantSubtabla';
import './TenantForm.css';

function TenantForm({ open, onClose, tenant, onSave }) {
    const [formData, setFormData] = useState({
        codTenant: '',
        name: '',
        enabled: true
    });

    const [tablaSeleccionada, setTablaSeleccionada] = useState('plataformas');

    const isEditMode = tenant && tenant._id;

    useEffect(() => {
        if (tenant) {
            setFormData({
                ...tenant,
                codTenant: tenant.codTenant || '',
                name: tenant.name || '',
                enabled: tenant.enabled !== undefined ? tenant.enabled : true
            });
        } else {
            setFormData({
                codTenant: '',
                name: '',
                enabled: true
            });
        }
    }, [tenant, open]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = () => {
        onSave(formData);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogTitle sx={{ backgroundColor: '#3d4d87', color: 'white' }}>
                {isEditMode ? 'Editar Tenant' : 'Nuevo Tenant'}
            </DialogTitle>
            <DialogContent sx={{ minHeight: '550px', paddingTop: '1rem !important' }}>
                {/* Formulario principal - Datos Generales */}
                <div className="tenantForm">
                    <div className="tenantFormHeader">
                        <div className="inputGroup" id="codigoInputGroup">
                            <label>Código</label>
                            <input
                                disabled={isEditMode}
                                name="codTenant"
                                value={formData.codTenant}
                                onChange={(e) => setFormData({...formData, codTenant: e.target.value.toUpperCase()})}
                            />
                        </div>
                        <div className="inputGroup" id="nombreInputGroup">
                            <label>Nombre</label>
                            <input
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="inputGroup" id="enabledInputGroup">
                            <label>Activo</label>
                            <input
                                type="checkbox"
                                name="enabled"
                                checked={formData.enabled}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    {/* Pestañas abajo */}
                    <div className="tablasHijasDiv">
                        <div className="opcionesHijasDiv">
                            <button
                                className={`opcionHijaBtn ${tablaSeleccionada === 'plataformas' ? 'selected' : ''}`}
                                onClick={() => setTablaSeleccionada('plataformas')}
                            >
                                Plataformas
                            </button>
                        </div>
                        <PlataformaTenantSubtabla
                            tenantId={tenant?._id}
                            tablaSeleccionada={tablaSeleccionada}
                        />
                    </div>
                </div>
            </DialogContent>
            <DialogActions sx={{ padding: 2, justifyContent: 'center', gap: 2 }}>
                <button className="saveTenantBtn" onClick={handleSubmit}>
                    {isEditMode ? 'Guardar Cambios' : 'Guardar'}
                </button>
                <button className="cancelTenantBtn" onClick={onClose}>
                    Cancelar
                </button>
            </DialogActions>
        </Dialog>
    );
}

export default TenantForm;
